module.exports = __webpack_public_path__ + "img/kaminski.b7276e8f.png";